'use client';

import { c as _c } from "react/compiler-runtime";
import { APIProvider } from '@vis.gl/react-google-maps';
import { PropsWithChildren } from 'react';
import { useDotEnv } from '@repo/dot-env/client';
export const GoogleMapsProvider = t0 => {
  const $ = _c(4);
  const {
    children
  } = t0;
  const env = useDotEnv();
  if (!env.GOOGLE_MAPS_API_KEY) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["marker"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children || $[2] !== env.GOOGLE_MAPS_API_KEY) {
    t2 = <APIProvider apiKey={env.GOOGLE_MAPS_API_KEY} libraries={t1} data-sentry-element="APIProvider" data-sentry-component="GoogleMapsProvider" data-sentry-source-file="provider.tsx">{children}</APIProvider>;
    $[1] = children;
    $[2] = env.GOOGLE_MAPS_API_KEY;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};